let score = 0

const updateHud = () => {
    const el = document.getElementById('scoreValue')
    if (el) el.innerText = score
}

const showFloatingPoint = () => {
    const floating = document.getElementById('floatingPoint')
    if (!floating) return

    floating.classList.add('show')

    // Rücksetzen nach der Animation
    setTimeout(() => {
        floating.classList.remove('show')
    }, 1000)
}

export default {
    add(points = 1) {
        score += points
        updateHud()
        showFloatingPoint()
    },
    reset() {
        score = 0
        updateHud()
    },
    get() {
        return score
    }
}
